import { Component } from 'vue-property-decorator';
import AbstractDisplayField from '../abstract-display-field/abstract-display-field';
import { mixins } from 'vue-class-component';

@Component({
  name: 'bpc-display-field-discount-rule',
  components: {},
})
export default class DisplayFieldDiscountRule extends mixins(AbstractDisplayField) {
  get valueLabel(): string {
    const item = this.fieldConfig.valueToLabel?.find(item => item.value === this.value);

    return item?.label || item?.text || this.value;
  }
}
